import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import {
  setIsOrderHintModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  setIsSignUpNoticeModalOpen,
} from '../../../../redux/modal/modal.actions';
import { AvForm } from 'availity-reactstrap-validation';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { hasEnabledNotificationMethods } from '../../../../utility/util/util.service';
import xss from 'xss';

const OrderHintModal = ({
  isOpen,
  me,
  orderHintModalData,
  store,
  data,

  setIsOrderHintModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
}) => {
  const [customerProfile, setCustomerProfile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (me?.requester && isOpen) {
      setCustomerProfile({
        ...me?.requester?.customerProfile,
        smsPhoneNumber:
          me?.requester?.customerProfile?.smsPhoneNumber ||
          me?.requester?.customerProfile?.tel,
      });
    }
  }, [me, isOpen]);

  const closeModal = () => {
    setIsOrderHintModalOpen(false);
    const orderType = data?.order?.type;
    const orderConfigKey = {
      SelfServiceOrder: 'selfServiceOrderConfig',
      PickupOrder: 'pickupOrderConfig',
      InhouseOrder: 'inhouseOrderConfig',
      DeliveryOrder: 'deliveryOrderConfig',
      CateringOrder: 'cateringOrderConfig',
    }[orderType];
    const currentOrderConfig = orderConfigKey ? store?.[orderConfigKey] : null;
    // Skip if config is still a string ID (not yet loaded)
    if (typeof currentOrderConfig === 'string') return;
    const hasNotificationMethods = hasEnabledNotificationMethods(currentOrderConfig);
    if (
      store?.merchantProfile?.enableCustomerOrderNotifications ||
      hasNotificationMethods
    ) {
      // Post-order registration prompt: clear any stale flags (e.g. isClosable
      // left over from the user-settings view) so the step stays mandatory.
      setOrderNotificationsModalData({});
      setIsOrderNotificationsModalOpen(true);
    }
  };

  const orderHintText = orderHintModalData?.text;

  const customXss = new xss.FilterXSS({
    whiteList: {
      p: [],
      b: [],
      br: [],
      em: [],
      u: [],
      i: [],
      strong: [],
      a: ['href', 'target'],
    },
  });

  const SanitizedHTML = ({ htmlContent, wrapperClassName }) => {
    const sanitizedHtml = customXss.process(htmlContent);

    return (
      <div
        className={`${wrapperClassName} no-margin-paragraphs`}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  };

  return (
    <Modal isOpen={isOpen} className="modal-dialog modal-dialog-centered">
      <AvForm>
        <ModalHeader className="bg-transparent px-1"></ModalHeader>
        <ModalBody className="text-center px-2 pt-0">
          <SanitizedHTML
            wrapperClassName="font-medium-1 black"
            htmlContent={orderHintText}
          />
        </ModalBody>
        <ModalFooter>
          <SaveSubmitButton
            isSubmitting={isSubmitting}
            onClick={closeModal}
            block
            color="primary"
            messageId="understandLabel"
          ></SaveSubmitButton>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isOrderHintModalOpen,
  cart: state.store.cart,
  store: state.store.store,
  table: state.store.table,
  me: state.me.me,
  data: state.modals.orderInfoModalData,
  orderHintModalData: state.modals.orderHintModalData,
});

export default connect(mapStateToProps, {
  setIsOrderHintModalOpen,
  setIsSignUpNoticeModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
})(OrderHintModal);
